import { useEffect, useState } from "react";
import { useOperatorUsers } from "./OperatorUsersContext";
import { Box, Button, Card, CardContent, CardHeader, Checkbox, Dialog, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputLabel, MenuItem, Select, Table, TableCell, TableRow, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { createOperatorUserAcc, updateOperatorUser, deleteOperatorUser } from "./utils";



const OperatorUserAccForm = () => {
    const [ open, setOpen ] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const {
        operatorUser,
        setOperatorUser,
        setReload,
        selectedOperatorUser,
        setSelectedOperatorUser,
        roles, 
        setRoles, 
        selectedRoleBtn, 
        setSelectedRoleBtn,
        agencies,
        setAgencies,
        selectedAgencyBtn,
        setSelectedAgencyBtn,
        filterValues
    } = useOperatorUsers()

    useEffect(()=>{
        // console.log("operatoruser-->"+operatorUser);
        // console.log("selectedOperatorUser-->"+selectedOperatorUser);
        // console.log("selectedOperatorUser-->"+selectedOperatorUser);
        setOpen(operatorUser !== null || selectedOperatorUser !== null)
    }, [operatorUser, selectedOperatorUser])

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setOperatorUser((prev) => ({ ...prev, [name]: value }));
      };

      const handleRoleBtn = (e) => {
        setSelectedRoleBtn(true)
      }

      const handleAgencyBtn = (e) => {
        setSelectedAgencyBtn(true)
      }

      const formValidate = (selectedOperatorUser) => {
        let newFormErrors = {};
        if(selectedOperatorUser.login===null || (selectedOperatorUser.login).trim() ===""){
            newFormErrors.login="Please Enter Login Name"
            setFormErrors(newFormErrors)
          }
        if(selectedOperatorUser.name===null || (selectedOperatorUser.name).trim() ===""){
            newFormErrors.name="Please Enter  Name"
            setFormErrors(newFormErrors)
          }
        if(selectedOperatorUser.email===null || (selectedOperatorUser.email).trim() ===""){
            newFormErrors.email="Please Enter Email Address"
            setFormErrors(newFormErrors)
          }
        if(selectedOperatorUser.company===null || (selectedOperatorUser.company).trim() ===""){
            newFormErrors.company="Please Enter Company Name"
            setFormErrors(newFormErrors)
          }
        if(selectedOperatorUser.jobTitle===null || (selectedOperatorUser.jobTitle).trim() ===""){
            newFormErrors.jobTitle="Please Enter Job Title"
            setFormErrors(newFormErrors)
          }
        if(Object.keys(newFormErrors).length>0)
            return false
            
          else
            return true
      }
    const updtUserAcc = (selectedOperatorUser) => {
        if (formValidate(selectedOperatorUser)){
        if(selectedOperatorUser.id===null)
            createOperatorUserAcc(selectedOperatorUser).then(() => {
            setSelectedOperatorUser(null);
            setOperatorUser(null);
            setReload(true);
            setFormErrors({})
          });
        else  
        updateOperatorUser(selectedOperatorUser).then(() => {
            setSelectedOperatorUser(null);
            setOperatorUser(null);
            setReload(true);
            setFormErrors({})
        });
      };
    };
    
      const delUserAcc = (selectedOperatorUser) => {
        deleteOperatorUser(selectedOperatorUser).then(() => {
            setSelectedOperatorUser(null);
            setOperatorUser(null);
            setReload(true);
        });
      };

    const onClose = (e, reason) => {
        setSelectedOperatorUser(null);
        setOperatorUser(null);
        setRoles(null);
        // setAgencies(null);
        setFormErrors({})
      };

      const convertDateISOToUTC = (isoDate) => {
        console.log("isoDate--->"+isoDate)
        if(isoDate !== null && isoDate !=="" ){
            const date = new Date(isoDate);
            const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
            return utcFormatted
        }
    };

var title="New Operator User Account"
  if(operatorUser){
        if(operatorUser.id)
            title="Edit Operator User Account"
  }

    return(
        operatorUser && (
            <Dialog maxWidth="true" open={open} onClose={onClose}>
                <IconButton
                aria-label="close"
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                }}
                onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
                <Card sx={{ borderRadius: 3 }}>
                    <CardHeader
                        title={<font className="layer-title"> {title} </font>}
                        align="center"
                        className={"styledtablerow"}
                    />
                    <CardContent
                        sx={{
                            paddingTop: 1,
                            paddingLeft: 0,
                            paddingRight: 0,
                            overflow: "auto",
                        }}
                    >
                        <Box component="form" size='small'
                            sx={{ '& .MuiTextField-root': { width: '35ch' }, paddingTop:3, align:'center', }} 
                        >
                            <Grid container spacing={{ xs: 1}}  sx={{paddingLeft:25}}>
                                <Grid alignItems={"stretch"}>
                                    <Table size="small">
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField
                                                    disabled
                                                    size="small"
                                                    id="operator-user-id"
                                                    label="ID"
                                                    value={operatorUser.id}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField
                                                    required 
                                                    size="small"
                                                    id="operator-user-login" 
                                                    label="Login" 
                                                    name="login"
                                                    value={operatorUser.login} 
                                                    onChange={handleChange}
                                                    error={formErrors.login}
                                                    helperText={formErrors.login}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    size="small"
                                                    id="operator-user-password" 
                                                    label="Password" 
                                                    value={operatorUser.password}
                                                    onChange={handleChange} 
                                                    name="password"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField
                                                    required 
                                                    size="small"
                                                    id="operator-user-name" 
                                                    label="Name" 
                                                    value={operatorUser.Name} 
                                                    onChange={handleChange}
                                                    name="name"
                                                    error={formErrors.name}
                                                    helperText={formErrors.name}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField fullWidth
                                                    required
                                                    size="small"
                                                    id="operator-user-email" 
                                                    label="Email" 
                                                    value={operatorUser.email} 
                                                    onChange={handleChange}
                                                    name = "email"
                                                    error={formErrors.email}
                                                    helperText={formErrors.email}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField
                                                    required 
                                                    size="small"
                                                    id="operator-user-company" 
                                                    label="Company" 
                                                    value={operatorUser.company} 
                                                    onChange={handleChange}
                                                    name="company"
                                                    error={formErrors.company}
                                                    helperText={formErrors.company}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    size="small"
                                                    id="operator-user-phoneNumber" 
                                                    label="Phone Number" 
                                                    value={operatorUser.phoneNumber} 
                                                    onChange={handleChange}
                                                    name="phoneNumber"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </Grid>
                                <Grid xs={6}>
                                    <Table size="small">
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    required
                                                    size="small"
                                                    id="operator-user-jobTitle" 
                                                    label="Job Title" 
                                                    value={operatorUser.jobTitle} 
                                                    onChange={handleChange}
                                                    name="jobTitle"
                                                    error={formErrors.jobTitle}
                                                    helperText={formErrors.jobTitle}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    size="small"
                                                    id="operator-user-faxNumber" 
                                                    label="Fax Number" 
                                                    value={operatorUser.faxNUmber}
                                                    onChange={handleChange}
                                                    name="faxNumber" 
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    size="small"
                                                    id="operator-user-approved" 
                                                    label="Approved" 
                                                    value={operatorUser.approved}
                                                    onChange={handleChange}
                                                    name="approved" 
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    size="small"
                                                    id="operator-user-updated" 
                                                    label="Updated" 
                                                    value={operatorUser.updated}
                                                    onChange={handleChange} 
                                                    name="updated"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                {(operatorUser.roles && operatorUser.roles.length > 0 && 
                                                    <Typography sx={{paddingLeft:1}}>
                                                        {JSON.stringify(operatorUser.roles)}
                                                    </Typography>
                                                )}
                                                <Button variant="outlined" label="SelectRoles" name="userRoles" value={operatorUser.roles} onClick={handleRoleBtn}> Select Roles </Button>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <TextField 
                                                    size="small"
                                                    id="operator-user-agencyId" 
                                                    label="Agency ID" 
                                                    value={operatorUser.agencyId}
                                                    onChange={handleChange} 
                                                    name="agencyId"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell  className={"tablecellnoborder"}>
                                                <FormControl>
                                                    <InputLabel id="message-Priority-label"> Agency </InputLabel>
                                                    <Select 
                                                        size="small"
                                                        sx={{minWidth:150}}
                                                        labelId="operator-user-Agency"
                                                        id="agency-selection"
                                                        value={operatorUser.agencyName}
                                                        label="Agency"
                                                        name="agencyName" 
                                                        onChange={handleChange}
                                                          
                                                    >
                                                    {agencies.map((eachagency) => (
                                                    <MenuItem
                                                        value={eachagency.name}
                                                        key={eachagency.id}
                                                    >
                                                    {eachagency.name}
                                                    </MenuItem>
                                                    ))}
                                                    </Select>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </Grid>
                                <Grid xs={6}>
                                    <Table size="small">
                                        <TableRow>
                                            <TableCell className={"tablecellnoborder"}>
                                                <FormGroup>
                                                    <FormControlLabel 
                                                        control={<Checkbox checked={operatorUser.neverExpires} onChange={(e) => {
                                                        setOperatorUser((operatorUser) => {
                                                        return {
                                                        ...operatorUser,
                                                        neverExpires: !operatorUser.neverExpires,
                                                        };
                                                        });
                                                        }}/>} 
                                                        label="Never expires" 
                                                    />
                                                </FormGroup>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Box> 
                        <Table>
                            <TableRow>
                                <TableCell align="right">
                                    <Button
                                        name="Save"
                                        label="Save"
                                        variant="outlined"
                                        size="small"
                                        onClick={(e) => updtUserAcc(operatorUser)}
                                    >
                                        Save 
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        name="Delete"
                                        label="Delete"
                                        variant="outlined"
                                        size="small"
                                        onClick={(e) => delUserAcc(operatorUser)}
                                    >
                                        Delete 
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </Table>
                    </CardContent>
                </Card>
            </Dialog>
        )
    )
};

export default OperatorUserAccForm;